'use client';

import { SidebarProvider, SidebarInset } from '../ui/sidebar';
import { SiteHeader } from './site-header.js';
import { SiteSidebar } from './site-sidebar.js';
import { useNavigation } from '../../hooks/use-navigation.js';
import { Outlet } from 'react-router-dom';  // import Outlet
import ReleaseAckModal from '../common/ReleaseAckModal';
import illustrator from "../../assets//illustrator/illus-background-2.png"
import { useEffect, useState } from 'react';

export function AppLayout() {
  const { navItems } = useNavigation();
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    // Detect dark mode by checking html class
    const observer = new MutationObserver(() => {
      setIsDark(document.documentElement.classList.contains("dark"));
    });
    observer.observe(document.documentElement, { attributes: true });
    setIsDark(document.documentElement.classList.contains("dark"));
    return () => observer.disconnect();
  }, []);

  return (
    <SidebarProvider>
      <SiteSidebar menuItems={navItems} />
      <SidebarInset className="!min-h-0 h-svh">
        <SiteHeader />
        <div
          className="flex-1 p-2 bg-cover bg-no-repeat overflow-y-auto min-h-0"
        >
          <Outlet />
        </div>
      </SidebarInset>
      {/* Mounted on the shell, not on a page: a pending release has to reach
          whoever signs in regardless of which route they land on. */}
      <ReleaseAckModal />
    </SidebarProvider>
  );
}